import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Connection } from '@/hooks/useNetworkingOptimized';

interface ContactSelectorProps {
  connections: Connection[];
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const ContactSelector = ({ connections, value, onValueChange, disabled }: ContactSelectorProps) => {
  if (connections.length === 0) {
    return (
      <div className="p-3 text-sm text-muted-foreground border rounded-md bg-muted">
        Aucune connexion disponible. Vous devez d'abord être connecté(e) avec d'autres membres pour pouvoir leur envoyer des messages.
      </div>
    );
  }

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger>
        <SelectValue placeholder="Sélectionner un contact" />
      </SelectTrigger>
      <SelectContent>
        {connections.map((connection) => (
          <SelectItem key={connection.id} value={connection.id}>
            <div className="flex items-center gap-3">
              <Avatar className="h-8 w-8">
                <AvatarImage src={connection.avatar_url} />
                <AvatarFallback>
                  {connection.firstname[0]}{connection.lastname[0]}
                </AvatarFallback>
              </Avatar>
              <div className="flex flex-col">
                <span className="font-medium">
                  {connection.firstname} {connection.lastname}
                </span>
                {connection.company && (
                  <span className="text-xs text-muted-foreground">
                    {connection.role && `${connection.role} chez `}{connection.company}
                  </span>
                )}
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ContactSelector;